// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
import { APIResource } from "../../core/resource.mjs";
import { buildHeaders } from "../../internal/headers.mjs";
import { path } from "../../internal/utils/path.mjs";
export class Passages extends APIResource {
    /**
     * Create a new passage in an archive.
     *
     * This adds a passage to the archive and creates embeddings for vector storage.
     */
    create(archiveID, body, options) {
        return this._client.post(path `/v1/archives/${archiveID}/passages`, { body, ...options });
    }
    /**
     * Delete a passage from an archive.
     *
     * This permanently removes the passage from both the database and vector storage
     * (if applicable).
     */
    delete(passageID, params, options) {
        const { archive_id } = params;
        return this._client.delete(path `/v1/archives/${archive_id}/passages/${passageID}`, {
            ...options,
            headers: buildHeaders([{ Accept: '*/*' }, options?.headers]),
        });
    }
    /**
     * Create multiple passages in an archive.
     *
     * This adds passages to the archive and creates embeddings for vector storage.
     */
    createMany(archiveID, body, options) {
        return this._client.post(path `/v1/archives/${archiveID}/passages/batch`, { body, ...options });
    }
}
//# sourceMappingURL=passages.mjs.map